<template lang="pug">
  v-container#header(fluid)
    v-layout(row wrap)
      v-flex(xs12)
        v-card.pb-3.pt-1(flat)
          v-layout(row wrap)
            v-flex(d-flex xs2 align-center)
              router-link.home(to="/")
                img.logo.ml-5(src="/static/rrm.png")
            v-flex(d-flex xs7)
              router-link.home(to="/")
                v-card-title.header-title.ml-5 Agresiones
            v-flex(d-flex xs2 align-center)
              v-btn.purple-btn.bold(@click="logout") Salir
    v-divider
</template>

<script>
export default {
  name: "Header",
  props: {},
  methods: {
    logout() {
      this.$store.commit("resetUser");
      localStorage.clear();
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped lang="scss">
#header {
  .home {
    text-decoration: none;
  }
  .logo {
    max-width: 120px;
  }
}
</style>
